import { render, staticRenderFns } from "./PaginaObtenerFactura.vue?vue&type=template&id=6e84b334&scoped=true&"
import script from "./PaginaObtenerFactura.vue?vue&type=script&lang=js&"
export * from "./PaginaObtenerFactura.vue?vue&type=script&lang=js&"
import style0 from "./PaginaObtenerFactura.vue?vue&type=style&index=0&id=6e84b334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84b334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VOverlay,VProgressCircular,VRow,VSpacer})
